import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=4894a5c8&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=4894a5c8&scoped=true&lang=css&"
import style1 from "./NewsDetails.vue?vue&type=style&index=1&id=4894a5c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894a5c8",
  null
  
)

export default component.exports